import { Card } from '@chakra-ui/react';
import React from 'react';

import { NextImageWrapper } from '@/modules/shared/presentation';
import type { Image } from '@/modules/shared/types';

type CompanyCardLogoProps = {
	image: Image
};

export const CompanyCardLogo = ({ image }: CompanyCardLogoProps) => {
	return (
		<Card.Root>
			<Card.Body>
				<NextImageWrapper aspectRatio="wide" image={image} objectFit="contain" sizes="100px" />
			</Card.Body>
		</Card.Root>
	);
};
